import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Switch } from './ui/switch';

// [Centre] Interrupteur « Fait la prépa » (indépendant du paiement, verrouillé si la prépa est payée)
export const PrepaToggle = ({ candidatId, value, payee, onChange, compact = false }) => {
  const [actif, setActif] = useState(!!value || !!payee);
  const [saving, setSaving] = useState(false);

  useEffect(() => { setActif(!!value || !!payee); }, [value, payee]);

  const basculer = async (nv) => {
    setSaving(true);
    try {
      await axios.put(`/candidats/${candidatId}/prepa`, { fait_prepa: nv });
      setActif(nv);
      onChange?.(nv);
      toast.success(nv ? 'Inscrit à la préparation' : 'Retiré de la préparation');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur');
    } finally {
      setSaving(false);
    }
  };

  return (
    <label className={`flex items-center gap-2 ${compact ? 'text-xs' : 'text-sm'} text-slate-700 cursor-pointer select-none`}
      title={payee ? 'Préparation payée' : 'Le candidat fait la journée de préparation'}>
      <Switch checked={actif} onCheckedChange={basculer} disabled={saving || payee} data-testid={`switch-prepa-${candidatId}`} />
      Fait la prépa
    </label>
  );
};
